const Logo = () => {
    return (
        <span>
            <h1>linkr</h1>
            <h2>save, share, and discover the best links on the web</h2>
        </span>
    )
}

export default Logo;